module.exports = __webpack_public_path__ + "img/finland-eye-and-ear-diseases-female.3f386d2c.png";